import styled from 'styled-components'
import {ContentHeader} from '../App'
import {useContext} from 'react'
import {OrderDataContext} from '../context/OrderDataContext'
import { LocationsContext } from '../context/AvailableDatesContext'
import { TranslationContext } from '../context/TranslationContext'

function Success() {
    const {order} = useContext(OrderDataContext)
    const { locations } = useContext(LocationsContext)
    const { translations } = useContext(TranslationContext)

    const locationMessage = () => (locations.find(location => location.location === order.location)?.location || '').toLowerCase()

    return (
        <Wrapper>
            <ContentHeader>
                <h1>{translations.thank_you}</h1>
                <p>
                    {translations.breakfast_sent_to_kitchen}
                </p>
                <p>{translations.see_you_simple} {order.date} @ <strong>{order.time} {translations[locationMessage()]}</strong> {String.fromCodePoint(0x1F924)}</p>
                <i>{translations.bon_apetit}</i>
            </ContentHeader>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
    justify-content: center;

    h1 {
        font-size: 50px !important;
        font-weight: 300 !important;
    }
`

export default Success
